class CustoMainProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

        $('.product__media-gallery-custom').css({"opacity":"1"});
  
        const sliders = document.querySelectorAll('.main-slider');
        const slidersthumb = document.querySelectorAll('.thumb-slider');


        const thumbSlidersInstances = [];
        const mainSlidersInstances = [];

        slidersthumb.forEach((thumbSlider, index) => {
          const thumbSwiper = new Swiper(thumbSlider, {
            spaceBetween: 15,
            direction: 'horizontal',
            slidesPerView: 5,
            breakpoints: {
              0: {
                slidesPerView: 5,
                spaceBetween: 20,
                direction: 'horizontal',
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 20,
                direction: 'horizontal',
              },
              1024: {
                slidesPerView: "auto",
                spaceBetween: 16,
                direction: 'vertical',
              },
              1441: {
                slidesPerView: "Auto",
                spaceBetween: 16,
                direction: 'vertical',
              },
            },
          });
          thumbSlidersInstances.push(thumbSwiper);
        });

        sliders.forEach((mainSlider, index) => {
          const mainSwiper = new Swiper(mainSlider, {
            spaceBetween: 0,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            thumbs: {
              swiper: thumbSlidersInstances[index],
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
                spaceBetween: 0,
                direction: 'horizontal',
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 0,
                direction: 'horizontal',
              },
            },
          });
          mainSlidersInstances.push(mainSwiper);
        });

        document.addEventListener("updateslider", (e) => {
          thumbSlidersInstances.forEach((thumbSwiper) => {
            thumbSwiper.slideTo(0);
          });
          mainSlidersInstances.forEach((mainSwiper) => {
            mainSwiper.slideTo(0);
          });
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-main-product-media", CustoMainProductMedia);